<template>
  <v-card
    class="rounded-xl textColor--text"
    max-height="456"
    height="456"
    rounded
    width="320"
  >
    <v-card-title style="display: flex; align-items: center">
      <v-skeleton-loader
        type="heading"
        width="160"
        height="24"
        class="gallery-card"
      ></v-skeleton-loader>
    </v-card-title>
    <v-card-subtitle>
      <v-skeleton-loader
        style="margin-top: 8px"
        type="text"
        class="gallery-card"
        width="100"
        height="16"
      ></v-skeleton-loader>
    </v-card-subtitle>
    <v-card-text>
      <div style="display: flex; align-items: center; justify-content: start">
        <v-skeleton-loader
          width="36"
          height="36"
          class="gallery-card"
          type="avatar"
          style="margin-right: 8px"
        ></v-skeleton-loader>
        <v-skeleton-loader
          class="gallery-card"
          type="text"
          width="200"
          height="16"
        ></v-skeleton-loader>
      </div>
      <div style="margin-top: 8px" class="image-grid">
        <v-skeleton-loader type="image" v-for="i in 4" :key="i" />
      </div>
      <div style="display: flex; justify-content: end; margin-top: 8px">
        <v-skeleton-loader
          type="text"
          width="100"
          height="16"
        ></v-skeleton-loader>
      </div>
    </v-card-text>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from "vue"

export default defineComponent({
  name: "GalleryDashboardCardLoader",
})
</script>

<style>
.image-grid {
  display: grid;
  grid-template-columns: 140px 140px;
  grid-template-rows: 140px 140px;
  gap: 8px;
}

.gallery-card .v-skeleton-loader__avatar {
  height: 100%;
  width: 100%;
}

.gallery-card .v-skeleton-loader__heading {
  height: 100%;
  width: 100%;
}

.gallery-card .v-skeleton-loader__text {
  height: 100%;
  width: 100%;
}
</style>
